import { LuSearch } from "react-icons/lu";
import { PiPlaceholder } from "react-icons/pi";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportProductQuotaCertificateNumber",
            label: "Quota Certificate No",
            component: "text-field",
          },
        ],
        row2: [
          {
            name: "exportProductQuotaQuantity",
            label: "Quantity",
            component: "text-field",
            dataType: "float",
            placeholder: "0.0000",
          },

        ],
        row3: [
          {
            name: "exportProductQuotaAgency",
            label: "Agency",
            component: "dropdown",
            defaultValue: "WWEPC",
            options: [
              { label: "AEPC", value: "AEPC" },
              { label: "AIHB", value: "AIHB" },
              { label: "APEDA", value: "APEDA" },
              { label: "ASI", value: "ASI" },
              { label: "CEPC", value: "CEPC" },
              { label: "CLRI", value: "CLRI" },
              { label: "COFFEE", value: "COFFEE" },
              { label: "CTEPC", value: "CTEPC" },
              { label: "HEPC", value: "HEPC" },
              { label: "N/A", value: "N/A" },
              { label: "SRTEPC", value: "SRTEPC" },
              { label: "WIB", value: "WIB" },
              { label: "WWEPC", value: "WWEPC" },
            ],
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportProductQuotaExpiryDate",
            label: "Expiry Date",
            component: "dateselector",
            width: "100%",
          },
        ],
        row2: [
          {
            name: "exportProductQuotaUnit",
            label: "Unit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
            icon: LuSearch,
            required: true,
          },
        ],
      },
    },
  ],
};
